import { AxiosError } from "axios";
import { HttpError, HttpStatusCode } from "./http-errors";
import i18next from "@/core/i18n/config";
import { errorConfig } from "./error-config";
import { ToastService } from "@/shared/services/toast-popup-services";

interface IToasterSettings {
  title?: string;
  message?: string;
  progress?: boolean;
  position?:
    | "top-right"
    | "top-center"
    | "top-left"
    | "bottom-right"
    | "bottom-left";
}

export class HttpErrorHandler {
  private static getErrorMessage(data: any): string {
    if (typeof data === "string") return data;
    if (data?.error) return data.error.message;
    return i18next.t("error:unknownError");
  }

  static handle(error: AxiosError, toasterSettings?: IToasterSettings): never {
    // Axios error'un içindeki request hatalarını yakalayalım
    if (error.request && !error.response) {
      return this.handleError(
        HttpStatusCode.NETWORK_ERROR,
        {
          message: i18next.t("error:networkError"),
        },
        toasterSettings
      );
    }
    // Normal API hataları
    if (error.response) {
      const { status, data } = error.response;
      return this.handleError(status, data, toasterSettings);
    }

    // Diğer tüm hatalar için
    return this.handleError(
      HttpStatusCode.INTERNAL_SERVER,
      {
        message: error.message,
      },
      toasterSettings
    );
  }

  private static handleError(
    status: number,
    data: any,
    toasterSettings?: IToasterSettings
  ): never {
    const errorMessage = data ? this.getErrorMessage(data) : "";
    const config =
      errorConfig[status] || errorConfig[HttpStatusCode.INTERNAL_SERVER];

    const httpError: HttpError = {
      statusCode: status,
      message: errorMessage || i18next.t(config.message),
      data,
      name: `HttpError${status}`,
    };

    ToastService.error({
      title: errorMessage || i18next.t(config.message),
      progress: false,
      ...(toasterSettings || {}),
    });

    if (config.callback) {
      config.callback();
    }

    throw httpError;
  }
}
